import { Link, useLocation } from "react-router-dom";
import { newsCategories, resourceTypes, topicTags } from "@/mocks/content";

const newsLinks = newsCategories.filter((item) => item !== "全部");

export default function CategorySidebar() {
  const location = useLocation();
  const pathname = decodeURIComponent(location.pathname);

  const isNewsActive = (category: string) => pathname === `/news/${category}` || pathname === `/news`;
  const isResourceActive = (type: string) => pathname === `/resources/${type}` || (pathname === `/resources` && type === "film");

  return (
    <div className="space-y-5">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h3 className="mb-3 flex items-center gap-2 text-[11px] font-medium tracking-[0.18em] text-foreground-500">
          <i className="ri-newspaper-line text-sm text-primary-500" aria-hidden="true"></i>
          资讯分类
        </h3>
        <ul className="space-y-0.5">
          <li>
            <Link
              to="/news"
              className={`flex cursor-pointer items-center justify-between rounded-md px-3 py-2 text-sm transition ${
                pathname === "/news" || pathname === "/news/all"
                  ? "bg-primary-50 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              全部资讯
              <i className="ri-arrow-right-s-line text-sm text-foreground-400" aria-hidden="true"></i>
            </Link>
          </li>
          {newsLinks.map((category) => (
            <li key={category}>
              <Link
                to={`/news/${encodeURIComponent(category)}`}
                className={`flex cursor-pointer items-center justify-between rounded-md px-3 py-2 text-sm transition ${
                  isNewsActive(category) && pathname !== "/news"
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h3 className="mb-3 flex items-center gap-2 text-[11px] font-medium tracking-[0.18em] text-foreground-500">
          <i className="ri-folder-open-line text-sm text-primary-500" aria-hidden="true"></i>
          资源类型
        </h3>
        <ul className="space-y-0.5">
          {resourceTypes.map((type) => (
            <li key={type.key}>
              <Link
                to={`/resources/${type.key}`}
                className={`flex cursor-pointer items-center justify-between rounded-md px-3 py-2 text-sm transition ${
                  isResourceActive(type.key) && pathname !== "/resources"
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {type.label}资源
                <i className={`ri-${type.key === "film" ? "film" : type.key === "game" ? "gamepad" : "book-open"}-line text-sm text-foreground-400`} aria-hidden="true"></i>
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/resources"
              className="flex cursor-pointer items-center justify-between rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:bg-background-100"
            >
              全部资源
              <i className="ri-arrow-right-s-line text-sm text-foreground-400" aria-hidden="true"></i>
            </Link>
          </li>
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h3 className="mb-3 flex items-center gap-2 text-[11px] font-medium tracking-[0.18em] text-foreground-500">
          <i className="ri-price-tag-3-line text-sm text-primary-500" aria-hidden="true"></i>
          热门标签
        </h3>
        <div className="flex flex-wrap gap-1.5">
          {topicTags.slice(1, 9).map((tag) => (
            <Link
              key={tag}
              to={`/topics?tag=${encodeURIComponent(tag)}`}
              className="cursor-pointer rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-800 transition hover:bg-accent-100 hover:text-accent-800"
            >
              #{tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-primary-200 bg-primary-50 p-4">
        <div className="flex items-center gap-2">
          <span className="flex h-6 w-6 items-center justify-center rounded-sm bg-primary-600 text-[10px] font-bold text-background-50">
            18+
          </span>
          <p className="text-xs font-semibold text-primary-800">成人内容提示</p>
        </div>
        <p className="mt-2.5 text-[11px] leading-relaxed text-primary-700/90">
          本站内容仅面向成年观众，所有作品信息与讨论均为虚构演示，不提供资源下载或外链跳转。
        </p>
        <Link
          to="/about"
          className="mt-3 inline-flex cursor-pointer items-center gap-1 text-[11px] font-medium text-primary-700 transition hover:text-primary-800"
        >
          查看内容声明
          <i className="ri-arrow-right-line text-xs" aria-hidden="true"></i>
        </Link>
      </div>
    </div>
  );
}